<template>
  <div class="main-container">
    <v-form 
        v-model="valid"
    >
    <v-container
        id="innerContainer"
    >
      <v-layout
        column
      >
        <v-flex
          xs12
          md4
        >
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Email"
            required
          ></v-text-field>
        </v-flex>

        <v-flex
          xs12
          md4
        >
          <v-text-field
            v-model="password"
            :rules="passwordRules"
            type="password"
            label="Password"
            required
          ></v-text-field>
        </v-flex>
        <v-btn 
            color="primary" 
            dark
            @click="login"
            :loading="loading"
        >
            Login
            
        </v-btn>
      </v-layout>
    </v-container>
    <v-expand-transition>
    <v-alert
      v-show="loginFailed"
      :value="true"
      color="error"
      icon="warning"
      id="incorrectLogin"
      outline
    >
      Login failed.
    </v-alert>
    </v-expand-transition>
  </v-form>
  </div>
</template>

<script>
import { CMS } from '../../api'
export default {
  created() {},
  data() {
    return {
        email: '',
        password: '',
        valid: false,
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
        passwordRules: [
            v => !!v || 'Password is required',
        ],
        loading: false,
        loginFailed: false
    };
  },
  computed: {},
  methods: {
     login() {
            let { loading, email, password, valid } = this
            if (!valid) return
            this.loading = true
            let payload = {
                email: email,
                password: password
            }
            CMS.login(this, payload, response => {
                console.log(response)
                if (!response ||
                    !response.data ||
                    !response.data.token) {
                    this.loginFailed = true
                    setTimeout(() => {
                        this.loginFailed = false
                    }, 2000)
                } else {
                    this.$store.dispatch('updateApiToken', response.data.token)
                    this.$router.push({ name: 'catagory'})
                }
                this.loading = false
            })
     }
  }
};
</script>

<style scoped>
.main-container {
    background-color: white; 
    width: 100vw; 
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.error--text {
    color: red !important;
}
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// Login.vue?fd4fdd92